<template>
    <n-result status="success" title="Success">
        <template #default>
            <div style="text-align:center">
                <p>Your request <b v-if="id">#{{id}}</b> has been submit, you will receive a notification email shortly.</p>
                <p>Our customer service team will contact you within the next <b>10 minutes</b>.</p>
            </div>
        </template>
        <template #footer>
            <n-button type="info" @click="close">OK</n-button>
        </template>
    </n-result>
</template>

<script>
import {NResult, NButton} from "naive-ui"
export default{
    name:"SuccessResult",
    props:["id", "modalClose"],
    components:{
        NResult, 
        NButton
    },
    setup(props,{emit}){
        const close = () =>{
            emit("modalClose")
        }
        return{
            close
        }
    }
}
</script>